import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var CheckoutApiService = /*#__PURE__*/function () {
  function CheckoutApiService() {
    _classCallCheck(this, CheckoutApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(CheckoutApiService, [{
    key: "GetInvoice",
    value: function GetInvoice(invoiceguid) {
      var url = "".concat(this._appRoot, "/Api/CheckoutApi/GetInvoice/").concat(invoiceguid);
      return Ajax.Get(url);
    }
  }, {
    key: "GetMyInvoices",
    value: function GetMyInvoices() {
      var url = "".concat(this._appRoot, "/Api/CheckoutApi/MyInvoices");
      return Ajax.Get(url);
    }
  }, {
    key: "BuildPaymentRequestToken",
    value: function BuildPaymentRequestToken(invoiceGuid, audienceUrl, returnUrl, amountToPay, paymentOption) {
      var url = "".concat(this._appRoot, "/Api/CheckoutApi/BuildPaymentRequestToken?invoiceId=").concat(invoiceGuid, "&audienceUrl=").concat(audienceUrl, "&returnUrl=").concat(returnUrl, "&amountToPay=").concat(amountToPay, "&paymentOption=").concat(paymentOption);
      return Ajax.Get(url);
    }
  }, {
    key: "ProcessPaymentResponse",
    value: function ProcessPaymentResponse(tokenPayload) {
      var url = "".concat(this._appRoot, "/Api/CheckoutApi/ProcessPaymentResponse");
      return Ajax.Post(url, tokenPayload);
    }
  }, {
    key: "DeleteEventRegistration",
    value: function DeleteEventRegistration(invoiceDetailId) {
      var url = "".concat(this._appRoot, "/Api/CheckoutApi/DeleteEventRegistration?invoiceDetailId=").concat(invoiceDetailId);
      return Ajax.Get(url);
    }
  }]);

  return CheckoutApiService;
}();